/**
 * @engine/vfx - Operator Nodes
 *
 * Math, random, and utility nodes available in any context.
 */

import type { VFXNodeDefinition } from '../../types';
import { dataPort } from '../../types';

/**
 * Operator node definitions.
 */

export const RANDOM_NODES: readonly VFXNodeDefinition[] = [

  {
    id: 'vfx.operator.random',
    name: 'Random',
    category: 'operator',
    contexts: [],
    description: 'Random value 0-1 (per particle, deterministic)',
    color: '#795548',
    inputs: [
      dataPort('seed', 'Seed', 'uint', { defaultValue: 0 }),
    ],
    outputs: [
      dataPort('result', 'Result', 'float'),
    ],
    shader: {
      code: `result = hash(particle.seed + seed);`,
    },
  },

  {
    id: 'vfx.operator.random_range',
    name: 'Random Range',
    category: 'operator',
    contexts: [],
    description: 'Random value in range',
    color: '#795548',
    inputs: [
      dataPort('min', 'Min', 'float', { defaultValue: 0 }),
      dataPort('max', 'Max', 'float', { defaultValue: 1 }),
      dataPort('seed', 'Seed', 'uint', { defaultValue: 0 }),
    ],
    outputs: [
      dataPort('result', 'Result', 'float'),
    ],
    shader: {
      code: `result = lerp(min, max, hash(particle.seed + seed));`,
    },
  },

  {
    id: 'vfx.operator.random_vec3',
    name: 'Random Vec3',
    category: 'operator',
    contexts: [],
    description: 'Random direction on unit sphere',
    color: '#795548',
    inputs: [
      dataPort('seed', 'Seed', 'uint', { defaultValue: 0 }),
    ],
    outputs: [
      dataPort('result', 'Result', 'vec3'),
    ],
    shader: {
      code: `result = normalize(hash3(particle.seed + seed) * 2.0 - 1.0);`,
    },
  },
];
